import {IncidentTaskState} from '../typedf'

export const checkIfDisabled = (state_id: number) => {
  return (
    state_id === IncidentTaskState.Closed_complete ||
    state_id === IncidentTaskState.Closed_incomplete ||
    state_id === IncidentTaskState.Closed_skipped
  )
}
